import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      // main: '#bac3b8',
      // main: '#b7e3e5',
      // main: '#c9eaec',
      main: '#d9d5c8',
    },
    secondary: {
      // main: '#d7ccb8',
      main: '#d9d5c8',
      // main: '#e3dfd6',
    },
  },
});

export default theme;
